"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { FIELD_TYPE_SELECTOR_MENU_DATA_ATTR } from '../../DataBuilder/FieldTypeSelector/index.mjs';
import { createContext, useContext, useRef, useEffect } from 'react';

const DropdownStackContext = createContext({
  isNested: false,
  stack: [],
  setStack: () => {
  }
});
const useDropdownStackContext = (dropdownRef) => {
  const { isNested, stack, setStack, editorRef } = useContext(DropdownStackContext);
  const mutableRefContainer = useRef(dropdownRef);
  useEffect(() => {
    if (isNested) {
      setStack((prev) => [...prev, mutableRefContainer?.current]);
    } else {
      setStack([mutableRefContainer?.current]);
    }
    return () => {
      setStack((prev) => prev.filter((record) => record !== mutableRefContainer?.current));
    };
  }, []);
  function isClickWithinStackItem(event) {
    const isClickOnCurrentEditor = editorRef?.current?.firstChild == event.target;
    const stackStartedFromElement = stack.slice(stack.indexOf(mutableRefContainer.current));
    const isClickInStack = stackStartedFromElement.some((ref) => {
      return !!(ref?.current && event.target instanceof Node && ref.current.contains(event.target));
    });
    const isClickInFieldTypeSelector = !!(event.target instanceof Element && event.target.closest(`[${FIELD_TYPE_SELECTOR_MENU_DATA_ATTR}]`));
    return isClickInStack || isClickOnCurrentEditor || isClickInFieldTypeSelector;
  }
  return { isClickWithinStackItem };
};

export { DropdownStackContext, useDropdownStackContext };
